<div class="d-flex flex-column min-vh-100">
  <nav class="navbar navbar-expand-lg bg-primary">
    <div class="container-fluid">
      <h2 class="navbar-brand text-light">RdSAP</h2>
      <div class="d-flex justify-content-end flex-grow-1"></div>
    </div>
  </nav>
  <div class="container my-auto text-center">
    <div *ngIf="errorImagePath">
      <img [src]="errorImagePath" [alt]="errorImageAlt" class="img-fluid" />
    </div>
    <h1 class="display-4 mb-4">{{ title }}</h1>
    <p class="lead text-danger">{{ errorMessage }}</p>
    <div class="error-actions">
      <!-- Temporarily solution until the AUTH API -->
      <a [attr.href]="url" class="btn btn-primary btn-lg">
        <span class="glyphicon glyphicon-home"></span> Take Me Home
      </a>
    </div>
  </div>
  <app-info class="mt-auto"></app-info>
</div>
